module.exports = __webpack_public_path__ + "img/linea-punteada-desp.1bdb3ea5.svg";